import * as React from 'react'
import { DownTime, DowntimePropertyName } from '../../../model/DownTime'
import { DateTimePicker } from '../../../common/DateTimePicker'
import ValidationMessageList from '../ValidationMessageList'

type Props = {
  downtimes?: DownTime[]
  newEvent: DownTime
  replaceDowntime: (downtime: DownTime) => void
  setInvalidDateValidationMessage: (downtime: DownTime, property: string) => void
}

type State = {
  timeOff: Date | undefined
}

export class DownTimeTimeOffInput extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      timeOff: props.newEvent.timeOff
    }
  }

  onBlur = (timeOff?: Date): void => {
    this.props.replaceDowntime({
      ...this.props.newEvent,
      timeOff
    })
  }

  onChange = (timeOff?: Date): void => {
    this.setState({
      timeOff
    })
  }

  isTimeOffValid = (): boolean => {
    return (
      this.props.newEvent.GetAllValidationMessagesForProperty(DowntimePropertyName.TimeOff)
        .length === 0
    )
  }

  public render(): JSX.Element {
    return (
      <div className="form">
        <DateTimePicker
          onChange={this.onChange}
          onBlur={this.onBlur}
          value={this.state.timeOff}
          inputClass={this.isTimeOffValid() ? 'form-control is-valid' : 'form-control is-invalid'}
        />
        <ValidationMessageList
          property={DowntimePropertyName.TimeOff}
          downtime={this.props.newEvent}
        />
      </div>
    )
  }
}

export default DownTimeTimeOffInput
